module.exports = __webpack_public_path__ + "resources/default_3.4f3835cace8aa180.png";


//////////////////
// WEBPACK FOOTER
// ../src/component/post-welfare-v2/img/default_3.png
// module id = 765
// module chunks = 0 2